import { useMemo } from 'react';
import { useLocation } from 'react-router';

export type LeaderboardType = 'per_gameweek' | 'overall';
export type PageType = 'readonly';

export interface ViewedTeamParams {
  teamId: string | undefined;
  gameweekId: string | undefined;
  leaderboardType: LeaderboardType | undefined;
  pageType: PageType | undefined;
  isViewMode: boolean;
}

export const useViewedTeamParams = (): ViewedTeamParams => {
  const location = useLocation();

  return useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const teamId = searchParams.get('teamId') ?? undefined;
    const gameweekId = searchParams.get('gameweekId') ?? undefined;
    const leaderboardType =
      (searchParams.get('leaderboardType') as LeaderboardType | null) ?? undefined;
    const pageType = (searchParams.get('pageType') as PageType | null) ?? undefined;

    return {
      teamId,
      gameweekId,
      leaderboardType,
      pageType,
      isViewMode: !!teamId,
    };
  }, [location.search]);
};
